// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import PinedSvg from '@rsuite/icon-font/lib/status/Pined';
var Pined = createSvgIcon({
  as: PinedSvg,
  ariaLabel: 'pined',
  category: 'status',
  displayName: 'Pined'
});
export default Pined;